// custom component (not registry-generated)
import type { VariantProps } from 'class-variance-authority'

import { cva } from 'class-variance-authority'

export { default as TextHighlight } from './TextHighlight.vue'

// The brand highlighter — a soft coloured marker bar sitting behind inline text.
// The bar is a REAL gaussian blur (`blur-xs`), not a drop-shadow halo: a
// coloured, transparent-text COPY of the phrase is rendered behind and blurred,
// while the crisp ink text sits on top — so the marker edge is genuinely soft
// yet the text stays sharp and legible. This recipe styles that BACKGROUND bar
// layer (colour + blur + radius); the crisp text, the a11y ink colour and the
// responsive line-height all live on the component.
//
// The bar copy is `box-decoration-clone` (box-decoration-break: clone + the
// -webkit- prefix) so it re-draws on EVERY line fragment when the phrase wraps.
// Multi-line readability is solved by LINE-HEIGHT — the component sets a roomy,
// em-relative `leading` so blurred bars never overlap, and it scales with the
// font on resize — never by weakening the blur.
//
// A11y: the component pins ink text (`text-foreground`), never the bar colour,
// so text is always legible — including `color="white"` (`bg-background`) over a
// coloured spotlight. Colours are tokens (lime `secondary` + the toolkit
// secondary stops), never raw palette.
export const textHighlightVariants = cva(
  'inline box-decoration-clone py-0.5 text-transparent',
  {
    variants: {
      color: {
        lime: 'bg-secondary',
        coral: 'bg-brand-coral',
        blue: 'bg-brand-blue',
        orange: 'bg-brand-orange',
        pink: 'bg-brand-pink',
        white: 'bg-background',
      },
      blur: {
        true: 'blur-xs',
        false: '',
      },
      rounded: {
        true: 'rounded-[10px]',
        false: '',
      },
    },
    defaultVariants: {
      color: 'lime',
      blur: true,
      rounded: true,
    },
  },
)
export type TextHighlightVariants = VariantProps<typeof textHighlightVariants>
